import { render, staticRenderFns } from "./RuleLinkGroupsDialog.vue?vue&type=template&id=557e1a46&scoped=true&"
import script from "./RuleLinkGroupsDialog.vue?vue&type=script&lang=js&"
export * from "./RuleLinkGroupsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557e1a46",
  null
  
)

export default component.exports